import FACTORY4_EXT_1 from "./FACTORY4_EXT_1";
export default {
  FACTORY4_EXT_1,
};
